import { ClientTextureUtils } from '../cl-texture-utils';

import { Canvas2DRenderPipeline } from './canvas2d-render-pipeline';
import { IRenderPipeline } from './render-pipeline.interface';
import { validateWebGLPipeline } from './webgl-support';
import { WebGLRenderPipeline } from './webgl-render-pipeline';

/**
 * Creates a render pipeline. If a WebGL context is provided, a WebGL render pipeline will be created.
 * Otherwise, a canvas 2D render pipeline will be created.
 * @param width - The width of the image.
 * @param height - The height of the image.
 * @param gl - The WebGL rendering context. If not provided, a new WebGL context will be created.
 * @returns The render pipeline.
 */
export function createRenderPipeline(width: number, height: number, gl?: WebGLRenderingContext): IRenderPipeline {
  const ownsContext = !gl;
  const glToUse = gl ?? ClientTextureUtils.tryCreateWebGL(width, height);

  if (!glToUse || !validateWebGLPipeline(glToUse, width, height)) {
    return new Canvas2DRenderPipeline(width, height);
  }

  return new WebGLRenderPipeline(glToUse, ownsContext);
}
